"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var Bonuses_1 = __importDefault(require("../../Bonuses"));
var ProcessingTotalInfo_1 = __importDefault(require("../FieldContent/ProcessingTotalInfo"));
var useDepositReturnLinks_1 = __importDefault(require("../FieldContent/useDepositReturnLinks"));
var AmountSum_1 = __importDefault(require("./AmountSum"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var SubmitButton_1 = __importDefault(require("./SubmitButton"));
var useInitialValues_1 = require("./useInitialValues");
var useValidationSchema_1 = require("./useValidationSchema");
var FieldContent = function (_a) {
    var selectedMethod = _a.selectedMethod, currentCurrency = _a.currentCurrency, type = _a.type, accountTypes = _a.accountTypes, paymentSettings = _a.paymentSettings;
    var t = (0, next_intl_1.useTranslations)('translation');
    var data = (0, swr_hooks_1.useUser)().data;
    var updateProfile = (0, swr_hooks_1.useUpdateProfileData)({}).updateProfile;
    var depositCallbackUrls = (0, useDepositReturnLinks_1.default)();
    var openWithdrawalAccepted = (0, apps_shared_1.useOpenWithdrawalAccepted)();
    var currencySettings = (0, react_1.useMemo)(function () {
        var _a;
        return (_a = selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.currencies) === null || _a === void 0 ? void 0 : _a.find(function (currency) { return currency.name === currentCurrency; });
    }, [selectedMethod, currentCurrency]);
    var _b = (0, swr_hooks_1.useMakeDeposit)({
        successAction: function (data) {
            var _a, _b, _c, _d;
            if ((_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.deposit) === null || _b === void 0 ? void 0 : _b.create) === null || _c === void 0 ? void 0 : _c.deposit) === null || _d === void 0 ? void 0 : _d.url)
                window.location.href = data === null || data === void 0 ? void 0 : data.data.deposit.create.deposit.url;
        },
    }), makeDeposit = _b.makeDeposit, isSubmitting = _b.isSubmitting;
    var _c = (0, swr_hooks_1.useMakeWithdrawal)({ successAction: openWithdrawalAccepted }), makeWithdrawal = _c.makeWithdrawal, withdrawalSubmitting = _c.isSubmitting;
    var minDep = (0, react_1.useMemo)(function () {
        var minDep = type === 'deposit' ? paymentSettings === null || paymentSettings === void 0 ? void 0 : paymentSettings.minDep : currencySettings === null || currencySettings === void 0 ? void 0 : currencySettings.min;
        return minDep ? String(minDep) : currencySettings === null || currencySettings === void 0 ? void 0 : currencySettings.min;
    }, [paymentSettings === null || paymentSettings === void 0 ? void 0 : paymentSettings.minDep, currencySettings === null || currencySettings === void 0 ? void 0 : currencySettings.min, type]);
    var initialValues = (0, useInitialValues_1.useInitialValues)({
        fields: selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.fields,
        min: minDep,
        type: type,
        accountTypes: accountTypes,
    });
    var validationSchema = (0, useValidationSchema_1.useValidateSchema)({
        fields: (selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.fields) || [],
        min: minDep,
        max: currencySettings === null || currencySettings === void 0 ? void 0 : currencySettings.max,
    });
    var onSubmitHandler = (0, react_1.useCallback)(function (_a) {
        var _b;
        var amount = _a.amount, values = __rest(_a, ["amount"]);
        if (type === 'deposit' && selectedMethod) {
            makeDeposit(__assign(__assign({ amount: String(amount), successUrl: depositCallbackUrls.success_url, cancelUrl: depositCallbackUrls.cancel_url, failUrl: depositCallbackUrls.fail_url, paymentMethod: selectedMethod.name }, values), { phone: "+".concat(values === null || values === void 0 ? void 0 : values.phone) }));
            try {
                updateProfile({
                    firstName: values.firstName,
                    lastName: values.lastName,
                    // gender: values.gender?.value,
                    // dateOfBirth: values.dateOfBirth,
                    city: values.city,
                    postalCode: values.postalCode || values.zip,
                    address: values.address,
                    phone: values === null || values === void 0 ? void 0 : values.phone,
                });
            }
            catch (err) { }
        }
        else if (selectedMethod) {
            makeWithdrawal(__assign(__assign({ amount: String(amount), paymentMethod: selectedMethod.name }, values), { accountType: (_b = values.accountType) === null || _b === void 0 ? void 0 : _b.value }));
        }
    }, [
        updateProfile,
        makeWithdrawal,
        type,
        makeDeposit,
        depositCallbackUrls,
        selectedMethod,
    ]);
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(isSubmitting ? styles_module_scss_1.default.loading : '') },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.header },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t(type === 'deposit' ? 'deposit' : 'withdrawal')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.commission },
                type === 'deposit' ? t('instant') + ' |' : '',
                " ",
                t('min'),
                " ",
                minDep,
                " -",
                ' ',
                t('max'),
                " ", currencySettings === null || currencySettings === void 0 ? void 0 :
                currencySettings.max)),
        react_1.default.createElement("br", null),
        react_1.default.createElement(react_final_form_1.Form, { onSubmit: onSubmitHandler, initialValues: initialValues, validate: validationSchema && (0, apps_shared_1.formValidator)(validationSchema), render: function (_a) {
                var _b;
                var handleSubmit = _a.handleSubmit, values = _a.values;
                return (react_1.default.createElement("form", { onSubmit: handleSubmit },
                    react_1.default.createElement(react_final_form_1.Field, { name: "amount" }, function (_a) {
                        var input = _a.input, meta = _a.meta;
                        return (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(AmountSum_1.default, { value: input.value, onChange: input.onChange, meta: meta, type: type })));
                    }),
                    type === 'deposit' && react_1.default.createElement(Bonuses_1.default, null), (_b = selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.fields) === null || _b === void 0 ? void 0 :
                    _b.map(function (el, idx) {
                        switch (el === null || el === void 0 ? void 0 : el.type) {
                            case 'amount':
                                return null;
                            case 'country':
                                return null;
                            case 'accountType':
                                return (react_1.default.createElement(react_final_form_1.Field, { name: "accountType", key: "field_name_".concat(el.type).concat(idx) }, function (_a) {
                                    var input = _a.input;
                                    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.accountTypeContainer },
                                        react_1.default.createElement(ui_components_1.InputSelect, __assign({ inputName: "accountType", options: accountTypes, labelText: t('account_type'), isSearchable: false, placeholder: t('selectAccountType') }, input))));
                                }));
                            case 'phone':
                                return (react_1.default.createElement(react_final_form_1.Field, { name: el.type, key: "field_name_".concat(el.type).concat(idx), render: function (_a) {
                                        var _b, _c, _d, _e, _f, _g, _h;
                                        var input = _a.input, meta = _a.meta;
                                        return (react_1.default.createElement("div", { className: styles_module_scss_1.default.inputWrapper }, ((_c = (_b = data === null || data === void 0 ? void 0 : data.profile) === null || _b === void 0 ? void 0 : _b.getOne) === null || _c === void 0 ? void 0 : _c.profile) && (react_1.default.createElement(ui_components_1.PhoneInput, __assign({}, input, { labelText: t("".concat(el.name, ".title")), placeholder: t("".concat(el.name, ".placeholder")), country: !(values === null || values === void 0 ? void 0 : values.phone)
                                                ? (_h = (_g = (_f = (_e = (_d = data === null || data === void 0 ? void 0 : data.profile) === null || _d === void 0 ? void 0 : _d.getOne) === null || _e === void 0 ? void 0 : _e.profile) === null || _f === void 0 ? void 0 : _f.location) === null || _g === void 0 ? void 0 : _g.country) === null || _h === void 0 ? void 0 : _h.toLowerCase()
                                                : undefined, helperButton: meta.error && meta.touched
                                                ? meta.touched && { type: 'error' }
                                                : undefined })))));
                                    } }));
                            default:
                                return (react_1.default.createElement(react_final_form_1.Field, { name: el.type, key: "field_name_".concat(el.type).concat(idx) }, function (_a) {
                                    var input = _a.input, meta = _a.meta;
                                    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.inputWrapper },
                                        react_1.default.createElement(ui_components_1.InputText, __assign({ labelText: t("".concat(el.name, ".title")), id: el.type, placeholder: t("".concat(el.name, ".placeholder")), type: el.type, helpertext: meta.error && meta.touched
                                                ? { status: 'error', text: meta.error }
                                                : undefined }, input))));
                                }));
                        }
                    }),
                    react_1.default.createElement("br", null),
                    type === 'deposit' ? (react_1.default.createElement(ProcessingTotalInfo_1.default, { fee: 0, totalAmount: values.amount, currency: currentCurrency })) : null,
                    react_1.default.createElement(SubmitButton_1.default, { loading: isSubmitting || withdrawalSubmitting, type: type, currency: currentCurrency, amount: values.amount, currencySettings: currencySettings })));
            } })));
};
exports.default = FieldContent;
